var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebDevIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web Dev Icon",
    clipPath: "url(#clip0_307_12163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M52.898 55.5103H11.102C5.33123 55.5103 0.653061 50.8321 0.653061 45.0613V18.9388C0.653061 13.168 5.33123 8.48985 11.102 8.48985H52.898C58.6688 8.48985 63.3469 13.168 63.3469 18.9388V45.0613C63.3469 50.8321 58.6688 55.5103 52.898 55.5103Z",
    stroke: "#D100C9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M42.449 47.6735H21.551C18.6656 47.6735 16.3265 45.3344 16.3265 42.449V21.551C16.3265 18.6656 18.6656 16.3265 21.551 16.3265H42.449C45.3344 16.3265 47.6735 18.6656 47.6735 21.551V42.449C47.6735 45.3344 45.3344 47.6735 42.449 47.6735Z",
    stroke: "#D100C9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M45.0612 63.3469H18.9388C13.168 63.3469 8.48979 58.6688 8.48979 52.8979V11.102C8.48979 5.33121 13.168 0.653046 18.9388 0.653046H45.0612C50.832 0.653046 55.5102 5.33121 55.5102 11.102V52.8979C55.5102 58.6688 50.832 63.3469 45.0612 63.3469Z",
    stroke: "#D100C9",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_307_12163"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebDevIcon);
export default __webpack_public_path__ + "static/media/WebDevIcon.5346dd33936453071f432f0b44466d5c.svg";
export { ForwardRef as ReactComponent };